var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4856 2.12584C12.1836 1.95805 11.8164 1.95805 11.5144 2.12584L2.51436 7.1258C2.03157 7.39401 1.85763 8.0028 2.12584 8.48558C2.39405 8.96836 3.00286 9.1423 3.48564 8.87409L12 4.14394L18.9409 7.99995L11.5144 12.1258C11.1969 12.3021 11 12.6367 11 12.9999V20.9998C11 21.3541 11.1875 21.682 11.4929 21.8617C11.7983 22.0414 12.1759 22.046 12.4856 21.874L21.4856 16.874C21.8031 16.6977 22 16.363 22 15.9999V8.0199C22.0014 7.94906 21.9951 7.87853 21.9817 7.80953C21.9718 7.75832 21.9579 7.7082 21.9403 7.65959C21.8614 7.44138 21.7067 7.24951 21.4885 7.12737M12.4856 2.12584L21.4845 7.12517L12.4856 2.12584ZM20 15.4115V9.69944L13 13.5883V19.3003L20 15.4115Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.99995C3.55228 6.99995 4 7.44767 4 7.99995V15.4115L12.4856 20.1257C12.9684 20.3939 13.1424 21.0027 12.8742 21.4855C12.6059 21.9682 11.9971 22.1422 11.5144 21.874L2.51436 16.874C2.19689 16.6977 2 16.363 2 15.9999V7.99995C2 7.44767 2.44772 6.99995 3 6.99995Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.12584 7.51431C2.39405 7.03153 3.00286 6.85758 3.48564 7.12579L12.4856 12.1257C12.9684 12.394 13.1424 13.0028 12.8742 13.4855C12.6059 13.9683 11.9971 14.1423 11.5144 13.874L2.51436 8.87409C2.03157 8.60588 1.85763 7.99708 2.12584 7.51431Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/orderIcon.34746873b029da97710ab588b04c8d07.svg";
export { ForwardRef as ReactComponent };